import { render } from "./detail.vue?vue&type=template&id=3febd3fb&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=3febd3fb&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3febd3fb"],['__file',"src/views/chess/order/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3febd3fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3febd3fb', __exports__)) {
    console.log('reload')
    api.reload('3febd3fb', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=3febd3fb&scoped=true", () => {
    console.log('re-render')
    api.rerender('3febd3fb', render)
  })

}


export default __exports__